import { observable, action, autorun, computed, toJS } from 'mobx'
import http from 'src/helper/http'
import cdn from 'src/helper/cdn'
import { history } from 'src/core/router'

export default class {
  @observable data = {
    remaintime: 0,
    uid: 0,
    userList: [],
    roomList: [],
    gifts: [],
    showPop: false,
    top1:{
    }
  }

  @action async GetWeeklyTop1(map) {
    let d = await http.post('/web/weekly/top1', map)
    if (d.code == 0) {
        this.data.top1 = d.res
    }
    return d.res
  }

  @action async GetServerTime(map) {
    let d = await http.post('/web/ServerTimeAr', map)
    if (d.code == 0) {
        this.data.remaintime = d.res.weekendts
    }
    return d.res
  }

  @action async setUid(uid) {
    this.data.uid = uid || 0
  }

  //用户排行
  @action async GiftWeekUserList(map) {
    let d = await http.post('/web/weekly/user/rank', map)
    if (d.code == 0) {
      for (let i = 0; i < d.res.length; i++) {
        if (d.res[i].val > 1000000) {
          d.res[i].val = parseInt(d.res[i].val / 100000) / 10 + 'M'
        } else if (d.res[i].val > 1000) {
          d.res[i].val = parseInt(d.res[i].val / 100) / 10 + 'K'
        }
        d.res[i].avatarurl = cdn(d.res[i].avatarurl)
      }
      this.data.userList = d.res
    }
  }

  //房间排行
  @action async GiftWeekGroupList(map) {
    let d = await http.post('/web/weekly/group/rank', map)
    if (d.code == 0) {
      for (let i = 0; i < d.res.length; i++) {
        if (d.res[i].val > 1000000) {
          d.res[i].val = parseInt(d.res[i].val / 100000) / 10 + 'M'
        } else if (d.res[i].val > 1000) {
          d.res[i].val = parseInt(d.res[i].val / 100) / 10 + 'K'
        }
        d.res[i].logourl = cdn(d.res[i].logourl)
      }
      this.data.roomList = d.res
    }
  }

  //每周礼物
  @action async WeekGiftList(map) {
    let d = await http.post('/web/weekly/gift', map)
    if (d.code == 0) {
      for (let i = 0; i < d.res.length; i++) {
        d.res[i].image = cdn(d.res[i].image)
      }
      this.data.gifts = d.res
    }
  }

}



// WEBPACK FOOTER //
// src/store/activity/weeklyStar.js